export default {
  pie: 'pie',
  donut: 'donut',
  progressDonut: 'progressDonut',
  simpleDistribution: 'simpleDistribution',
  axis: 'axis'
}
